module.exports = __webpack_public_path__ + "img/jg4.a650175c.png";